/**
 * Wire format of /api/q. Server Actions carried Date and undefined as they are; plain
 * JSON turns a Date into a string and an undefined array element into null, and an
 * action that calls getTime() on its argument, or relies on a missing optional
 * argument, would behave differently. So both are tagged on the way out and restored
 * on the way in.
 */
const DATE_TAG = "__date";
const UNDEFINED_TAG = "__undefined";

export function encodeArgs(args: unknown[]): string {
  return JSON.stringify({ args }, function (this: unknown, key: string, value: unknown) {
    const raw = (this as Record<string, unknown>)[key];
    if (raw instanceof Date) {
      return Number.isNaN(raw.getTime()) ? null : { [DATE_TAG]: raw.toISOString() };
    }
    if (raw === undefined && Array.isArray(this)) return { [UNDEFINED_TAG]: true };
    return value;
  });
}

export function decodeArgs(text: string): unknown {
  return JSON.parse(text, (_key, value: unknown) => {
    if (value && typeof value === "object" && !Array.isArray(value)) {
      const record = value as Record<string, unknown>;
      const keys = Object.keys(record);
      if (keys.length === 1 && keys[0] === DATE_TAG && typeof record[DATE_TAG] === "string") {
        return new Date(record[DATE_TAG]);
      }
      if (keys.length === 1 && keys[0] === UNDEFINED_TAG) return undefined;
    }
    return value;
  });
}
